<div>
  <img [src]="mercuryLogoPath" class="mercury-logo" alt="Mercury Logo" />
  <div class="col-12 body-medium text-tertiary subtitle-gap p-0">
    Recover Account
  </div>
  <div
    class="col-12 text-primary title-gap p-0 flex flex-wrap align-items-center"
  >
    <i class="icon-bx-check-circle icon-size-large" aria-hidden="true"></i>
    <div class="jumbo-medium">Success</div>
  </div>
  <div class="col-12 body-medium text-tertiary description-gap p-0">
    Password reset request was sent successfully. Please check your email to
    reset your password.
  </div>

  <div class="col-12 p-0">
    <button
      pButton
      class="p-button-primary w-full button-text-medium"
      routerLink="/login"
    >
      <span pButtonLabel>Back to Login</span>
    </button>
  </div>
</div>
